module.exports = __webpack_public_path__ + "files/10e91491159b0c5e3c6eadc7fc4fe7a1.svg";